import script from "./InternalTicketsAssigned.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalTicketsAssigned.vue?vue&type=script&setup=true&lang=js"

import "./InternalTicketsAssigned.vue?vue&type=style&index=0&id=238fe186&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-238fe186"]])

export default __exports__